<template>
  <div class="edu_pages">
    <div class="edu_pages_content_box">
      <div class="edu_page_title_box">
        <div class="title_box">
          <div class="color_lump_box"></div>
          <span>下属街道管理</span>
        </div>
        <div class="edu_operation_box">
          <div class="add_icon_box button-box" @click="addClick()">
            <div></div>
            <span>新增</span>
          </div>
        </div>
      </div>
      <div class="edu_pages_content_body_box">
        <div class="edu_table_box">
          <el-table
            :data="tableData"
            height="100%"
            :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
            class="table_box"
          >
            <el-table-column label="序号" width="70" align="center">
              <template slot-scope="scope">
                {{
                  searchParams.pageSize * (searchParams.pageNum - 1) +
                    scope.$index +
                    1
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="regionCode"
              label="区域编码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="regionName"
              label="区域名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="parCode"
              label="上级区域编码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="directorName"
              label="负责人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="directorPhone"
              label="负责人手机号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="rowData">
                <el-link
                  type="primary"
                  @click="editClick(rowData.row)"
                  :underline="false"
                  >编辑</el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="edu_pagination_box">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page="searchParams.pageNum"
            :page-size="searchParams.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="type == 'add' ? '新增下属街道' : '修改下属街道'"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      :visible.sync="showAddOrEdit"
      width="40%"
    >
      <div class="dialog_box">
        <el-form
          :model="addOrEditInfo"
          :rules="rules"
          ref="ruleForm"
          label-width="0px"
        >
          <div class="form-row-item-box">
            <div class="form-item-box">
              <span>区域编码:</span>
              <el-form-item prop="regionCode">
                <el-input
                  v-model.trim="addOrEditInfo.regionCode"
                  size="small"
                  :maxlength="16"
                  clearable
                  style="width:100%"
                  :disabled="type == 'edit'"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-item-box">
              <span>区域名称:</span>
              <el-form-item prop="regionName">
                <el-input
                  v-model.trim="addOrEditInfo.regionName"
                  size="small"
                  :maxlength="32"
                  clearable
                  style="width:100%"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-row-item-box">
            <div class="form-item-box">
              <el-tooltip
                class="item"
                effect="light"
                content="负责该区域下，所有督查小组工作任务的最终审核，请谨慎修改"
                placement="top"
              >
                <span>负责人:</span>
              </el-tooltip>
              <el-form-item prop="director">
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="addOrEditInfo.director"
                  @change="directorChange"
                  style="width:100%"
                  placeholder="请选择负责人"
                >
                  <el-option
                    v-for="item in principalList"
                    :key="item.userId"
                    :label="item.userName"
                    :value="item.userId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-item-box">
              <span>手机号:</span>
              <el-form-item prop="directorPhone">
                <el-input
                  v-model.trim="addOrEditInfo.directorPhone"
                  size="small"
                  style="width:100%"
                  :maxlength="13"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="dialog_save_cancel_box">
          <div class="cancel_item_box" @click="handleClose">取消</div>
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              街道信息一旦保存成功<br />只可编辑，无法删除<br />请谨慎编辑街道信息
            </div>

            <div class="save_item_box" @click="sendEduData('ruleForm')">
              确定
            </div>
          </el-tooltip>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "bureauEdu",
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      searchParams: {
        parCode: this.$store.getters.getEduData.regionCode,
        pageNum: 1,
        pageSize: 20
      },
      tableData: [],
      total: 0,
      addOrEditInfo: {
        id: "", //编号（编辑时传）
        regionCode: "", //区域编码(不可编辑)
        regionName: "", //区域名称(可编辑)
        parCode: this.$store.getters.getEduData.regionCode, //上级区域编码(不可编辑)
        director: "", //负责人id
        directorPhone: "" //负责人手机号
      },
      type: "add",
      showAddOrEdit: false,
      principalList: [], //负责人列表
      rules: {
        regionCode: [{ required: true, message: " ", trigger: "blur" }],
        regionName: [{ required: true, message: " ", trigger: "blur" }],
        director: [{ required: true, message: " ", trigger: "change" }],
        directorPhone: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    this.getPrincipalList();
    this.searchData();
  },
  methods: {
    async getPrincipalList() {
      let res = await this.$Http.getBureauUserList({
        eduId: this.$store.getters.getUserInfo.eduId
      });
      if (res.code == 200) {
        this.principalList = res.data[0].users || [];
      } else if (res.code == 101) {
        this.principalList = [];
      } else {
        this.principalList = [];
      }
    },
    directorChange(val) {
      this.principalList.forEach((item) => {
        if (val == item.userId) {
          this.addOrEditInfo.directorPhone = item.userPhone || "";
        }
      });
    },
    async searchData() {
      let res = await this.$Http.getEduBureauList(this.searchParams);
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.$message({
          message: "下属机构获取失败",
          type: "error"
        });
        this.tableData = [];
        this.total = 0;
      }
    },
    handleCurrentChange(val) {
      this.searchParams.pageNum = val;
      this.searchData();
    },
    addClick() {
      this.type = "add";
      this.addOrEditInfo = {
        regionCode: "", //区域编码(不可编辑)
        regionName: "", //区域名称(可编辑)
        parCode: this.$store.getters.getEduData.regionCode, //上级区域编码(不可编辑)
        director: "", //负责人id
        directorPhone: "" //负责人手机号
      };
      this.showAddOrEdit = true;
    },
    editClick(val) {
      this.type = "edit";
      this.addOrEditInfo = Object.assign({}, val);
      this.addOrEditInfo.director == 0
        ? (this.addOrEditInfo.director = "")
        : (this.addOrEditInfo.director = this.addOrEditInfo.director);
      this.showAddOrEdit = true;
    },
    handleClose() {
      this.showAddOrEdit = false;
      this.$refs.ruleForm.resetFields();
    },
    sendEduData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addOrEditEduBureau();
        } else {
          return false;
        }
      });
    },
    async addOrEditEduBureau() {
      let res = await this.$Http.addOrEditEduBureau(this.addOrEditInfo, true);
      if (res.code == 200) {
        this.handleClose();
        this.searchData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: this.type == "add" ? "新增失败" : "修改失败",
          type: "error"
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../../../public/css/edu_pages.scss";
</style>
